import { render, staticRenderFns } from "./type101.vue?vue&type=template&id=c62dd25c&scoped=true"
import script from "./type101.vue?vue&type=script&lang=js"
export * from "./type101.vue?vue&type=script&lang=js"
import style0 from "./type101.vue?vue&type=style&index=0&id=c62dd25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62dd25c",
  null
  
)

export default component.exports